import { createContext as t } from "react";
const o = t(null), a = {
  activeCategory: "",
  openCategory: "",
  activeItem: ""
};
export {
  o as GlobalNavContext,
  a as defaultGlobalNavContextState
};
